import { Injectable,} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AwsSignerService } from '../aws-signer/aws-signer.service';
import { CognitoService } from '../cognito/cognito.service';
//@ts-ignore
import { environment } from '../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class ReportListService {
  hasJustRegistered: boolean;
  hasJustUpdated: boolean;
  hasJustDeleted: boolean;

  constructor(private http: HttpClient,
    private cognitoService: CognitoService,
    private awsSignerService: AwsSignerService) {
    this.hasJustRegistered = false;
    this.hasJustUpdated = false;
    this.hasJustDeleted = false;
  }

  private getUrl() {
    return `${localStorage.getItem('region-api')}/report`;
  }

  generateAWSHeader(url: string, method: string, body: any) {
    const awsHeaders = this.awsSignerService.getAwsHeader(url, method, body);
    const headerParams = {
      'Content-Type': 'application/json',
      'Authorization': awsHeaders['Authorization'],
      'X-Amz-Date': awsHeaders['X-Amz-Date'],
      'x-amz-security-token': awsHeaders['x-amz-security-token'],
      'x-api-key': environment.cesAPI.apiKey,
    };

    return {
      //@ts-ignore
      headers: new HttpHeaders(headerParams)
    };
  }

  getReportList(password: string, path: string, currentPath: string): Observable<any> {
    if (!this.cognitoService.isAuthenticated()) {
      this.cognitoService.authAzure();
    }

    let url = this.getUrl() + "/list";
    const emailAddress = this.cognitoService.getEmailAddress();
    const requestBody = {
      password,
      path,
      emailAddress,
      currentPath,
    };

    // const httpOptions = {}
    const httpOptions = this.generateAWSHeader(url, 'POST', requestBody);

    return this.http.post(url, requestBody, httpOptions);
  }

  getDownloadFileUrl(fileKey: string, password: string, path: string, currentPath: string): Observable<any> {
    if (!this.cognitoService.isAuthenticated()) {
      this.cognitoService.authAzure();
    }

    let url = this.getUrl() + "/download";

    const emailAddress = this.cognitoService.getEmailAddress();
    const requestBody = {
      fileKey,
      password,
      path,
      emailAddress,
      currentPath,
    };

    // const httpOptions = {}
    const httpOptions = this.generateAWSHeader(url, 'POST', requestBody);

    return this.http.post(url, requestBody, httpOptions);
  }
}